module.exports = __webpack_public_path__ + "img/15-half-sm.67d7a263.jpg";